import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessHelpCategories, canAccessInterestGroups } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { helpCategoriesRoutes, interestGroupsRoutes } from "./routes";

export const helpCategoriesRoute = [
  {
    path: helpCategoriesRoutes.list,
    lazy: async () => {
      const { HelpCategoryListPage } = await import("./pages/help-category/HelpCategoryListPage");

      return {
        element: (
          <RequireAuth permission={canAccessHelpCategories}>
            <HelpCategoryListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: helpCategoriesRoutes.create,
    lazy: async () => {
      const { CreateHelpCategoryPage } = await import("./pages/help-category/CreateHelpCategoryPage");

      return {
        element: (
          <RequireAuth permission={(x) => x.isAdmin && x.community.canCreateGroup}>
            <CreateHelpCategoryPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: helpCategoriesRoutes.details,
    lazy: async () => {
      const { GroupDetailsPage } = await import("./pages/group-details/GroupDetailsPage");

      return { element: <GroupDetailsPage /> };
    },
  },
  {
    path: helpCategoriesRoutes.edit,
    lazy: async () => {
      const { EditHelpCategoryPage } = await import("./pages/help-category/EditHelpCategoryPage");

      return { element: <EditHelpCategoryPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];

export const interestGroupsRoute = [
  {
    path: interestGroupsRoutes.list,
    lazy: async () => {
      const { InterestGroupListPage } = await import("./pages/interest-group/InterestGroupListPage");

      return {
        element: (
          <RequireAuth permission={canAccessInterestGroups}>
            <InterestGroupListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: interestGroupsRoutes.create,
    lazy: async () => {
      const { CreateInterestGroupPage } = await import("./pages/interest-group/CreateInterestGroupPage");

      return {
        element: (
          <RequireAuth permission={(x) => x.community.canCreateGroup}>
            <CreateInterestGroupPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: helpCategoriesRoutes.details,
    lazy: async () => {
      const { GroupDetailsPage } = await import("./pages/group-details/GroupDetailsPage");

      return { element: <GroupDetailsPage /> };
    },
  },
  {
    path: interestGroupsRoutes.edit,
    lazy: async () => {
      const { EditInterestGroupPage } = await import("./pages/interest-group/EditInterestGroupPage");

      return { element: <EditInterestGroupPage /> };
    },
  },
  {
    path: interestGroupsRoutes.createResidentGroup,
    lazy: async () => {
      const { CreateResidentGroupPage } = await import("./pages/resident-group/CreateResidentGroupPage");

      return {
        element: (
          <RequireAuth permission={(x) => x.community.canCreateGroup}>
            <CreateResidentGroupPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: interestGroupsRoutes.editResidentGroup,
    lazy: async () => {
      const { EditResidentGroupPage } = await import("./pages/resident-group/EditResidentGroupPage");

      return { element: <EditResidentGroupPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
